module.exports = __webpack_public_path__ + "img/bus-e.d5270cec.png";